/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Editor_Select_Event_GroupInputs */

const en_editor_select_event_group = /** @type {(inputs: Editor_Select_Event_GroupInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Select event group ${i?.name}`)
};

const fr_editor_select_event_group = /** @type {(inputs: Editor_Select_Event_GroupInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Selectionner le groupe d'evenements ${i?.name}`)
};

const de_editor_select_event_group = /** @type {(inputs: Editor_Select_Event_GroupInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ereignisgruppe ${i?.name} auswählen`)
};

const it_editor_select_event_group = /** @type {(inputs: Editor_Select_Event_GroupInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Seleziona il gruppo di eventi ${i?.name}`)
};

const ru_editor_select_event_group = /** @type {(inputs: Editor_Select_Event_GroupInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Выберите группу событий ${i?.name}`)
};

const es_editor_select_event_group = /** @type {(inputs: Editor_Select_Event_GroupInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Seleccionar grupo de eventos ${i?.name}`)
};

const zh_cn2_editor_select_event_group = /** @type {(inputs: Editor_Select_Event_GroupInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`选择事件组${i?.name}`)
};

const ja_editor_select_event_group = /** @type {(inputs: Editor_Select_Event_GroupInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`イベントグループを選択 ${i?.name}`)
};

const hi_editor_select_event_group = /** @type {(inputs: Editor_Select_Event_GroupInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`इवेंट समूह ${i?.name} का चयन करें`)
};

const pt_pt2_editor_select_event_group = /** @type {(inputs: Editor_Select_Event_GroupInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Selecione o grupo de eventos ${i?.name}`)
};

/**
* | output |
* | --- |
* | "Select event group {name}" |
*
* @param {Editor_Select_Event_GroupInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const editor_select_event_group = /** @type {((inputs: Editor_Select_Event_GroupInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Select_Event_GroupInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_editor_select_event_group(inputs)
	if (locale === "de") return de_editor_select_event_group(inputs)
	if (locale === "it") return it_editor_select_event_group(inputs)
	if (locale === "ru") return ru_editor_select_event_group(inputs)
	if (locale === "es") return es_editor_select_event_group(inputs)
	if (locale === "zh-CN") return zh_cn2_editor_select_event_group(inputs)
	if (locale === "ja") return ja_editor_select_event_group(inputs)
	if (locale === "hi") return hi_editor_select_event_group(inputs)
	if (locale === "pt-PT") return pt_pt2_editor_select_event_group(inputs)
	return en_editor_select_event_group(inputs)
});